import {ValueObject} from '@s-ui/domain'

export class AvailableMarketedYearsValueObject extends ValueObject {
  /**
   * @param {Object} params
   * @param {Array<MarketedYearValueObject>} params.items
   * */
}
